import { Link } from 'react-router-dom'
import { Typogaphy } from 'vnetwork-ui'

interface CellLinkProps {
    to: string
    className?: string
    unHighlight?: boolean
    children: React.ReactNode
}

const CellLink: React.FC<CellLinkProps> = ({
    to,
    children,
    className,
    unHighlight,
}) => {
    return (
        <Link to={to} className={`inline-block ${className}`}>
            <Typogaphy
                className={`${unHighlight ? '' : 'underline text-blue-600'}`}
                size="small"
            >
                {children}
            </Typogaphy>
        </Link>
    )
}

export default CellLink
